class Popup extends HTMLElement {
	constructor() {
		super();
		this.popup = null;
	}
	init() {
		this.initPopupJs();
	}
	initPopupJs(
		content = '',
		title = '',
		id = '',
		header = true,
		footer = true,
		timeShow = 0
	) {
		const _this = this;
		this.popup = EasyDialogBox.create(
			id,
			`dlg ${header == false ? 'dlg-disable-heading ' : ''}${
				footer == false ? 'dlg-disable-footer ' : ''
			}dlg-disable-drag`,
			title,
			content
		);
		this.popup.onShow = function () {
			// Initialize size guide functionality after dialog is shown
			_this.initSizeGuideToggle();
		};
		this.popup.onClose = function () {
			removeTrapFocus();
			_this.popup.destroy();
			rootAction.remove();
			root.style.removeProperty('padding-right');
			if (_this.querySelector('button') && _this.querySelector('button').id) {
				if (document.querySelector('#' + _this.querySelector('button').id)) {
					document
						.querySelector('#' + _this.querySelector('button').id)
						.focus();
				}
			}
			getHeightHeader.init();
		};
		this.popup.show(timeShow);
	}

	initSizeGuideToggle() {
		const sizeGuideWrapper = document.querySelector(
			'[data-size-guide-wrapper]'
		);
		if (!sizeGuideWrapper) return;

		const toggle = sizeGuideWrapper.querySelector('.unit-toggle');
		const labels = sizeGuideWrapper.querySelectorAll('.unit-label');
		const measurementCells =
			sizeGuideWrapper.querySelectorAll('.measurement-cell');

		if (!toggle || !labels.length || !measurementCells.length) return;

		const CM_PER_IN = 2.54;

		const convertVal = (val, toCm) => {
			return val.replace(/([0-9]+(?:\.[0-9]+)?)/g, (match) => {
				const num = parseFloat(match);
				if (isNaN(num)) return match;
				const converted = toCm ? num * CM_PER_IN : num / CM_PER_IN;
				return (Math.round(converted * 10) / 10).toString();
			});
		};

		const updateLabels = () => {
			const isCm = toggle.checked;
			labels.forEach((label) => {
				const unit = label.dataset.unit;
				if ((isCm && unit === 'cm') || (!isCm && unit === 'in')) {
					label.classList.add('active');
				} else {
					label.classList.remove('active');
				}
			});
		};

		const refresh = () => {
			const isCm = toggle.checked;
			measurementCells.forEach((cell) => {
				const rawCm = cell.dataset.cm;
				if (isCm) {
					cell.textContent = rawCm; // Show original CM values
				} else {
					cell.textContent = convertVal(rawCm, false); // Convert CM to IN
				}
			});
			updateLabels();
		};

		// Remove any existing event listeners and add new one
		toggle.removeEventListener('change', refresh);
		toggle.addEventListener('change', refresh);

		// Set initial state
		updateLabels();
	}
}
